const ConfigurationFactory = require("../ConfigurationFactory");
const Logger = require("../Logger");

const AFFECTED_COMPANY_IDS = [
  "3ff69fad-fc75-4e8f-be8d-343d50af42f0",
  "4e22da3e-bcd1-439a-b6e0-5f07e3b1d7cf",
  "5e0f0bca-7f5c-40a5-8547-7db1c2fefc90",
  "6ce78836-aec6-44d2-a3db-d60859d136ad",
  "6f7c56df-e911-48d0-b975-1cae72230b50",
  "7dba1066-d5ba-40b4-9213-87009e8ac22b",
  "9d24180f-3ca5-4510-957f-ea34b9107799",
  "a90a2abe-da5b-4a72-8314-f6d33db638c8",
  "bbf27c5b-544a-4fb5-bb6a-4e974021c552",
  "d3939b1d-639d-4009-8c61-91f61a98e52a",
  "dba9e8c2-b88e-4b13-836a-06f4201e0338",
  "de3d91cd-7153-44bb-96f6-8edb48305e17",
  "e43d521f-80fb-4677-8d34-32a68b0ed559",
  "b428b4e8-c8b9-41d5-8a10-b4193c789443" // Test company
]

let audio = null
const service = {}

service.shouldApplyWorkaround = () => {
  // Enable for Promethean D Series, while a configuration solution is found
  if( ConfigurationFactory.isPrometheanDSeries() ) {
    return true
  }

  if (!ConfigurationFactory.isGiadaRecommendedDevice()) {
    return false
  }

  const companyId = ConfigurationFactory.getCompanyId()
  return AFFECTED_COMPANY_IDS.includes( companyId )
}

service.init = () => {
  // Prevent multiple instances
  if (audio) {
    return
  }

  if (!service.shouldApplyWorkaround()) {
    return
  }

  Logger.viewerImportant( "Applying background state prevention workaround", JSON.stringify({
    companyId: ConfigurationFactory.getCompanyId()
  }))

  audio = new Audio('https://storage.googleapis.com/widgets.risevision.com/recordings/silent.mp3')
  audio.loop = true
  audio.volume = 0.01

  audio.play().catch((error) => {
    Logger.viewerError( "E999999999", "unable to play silent audio", JSON.stringify({
      error: error && ( error.stack || error.message )
    }))
  })
}

module.exports = service
